<template>
  <validation-observer ref="work-status-values-observer">
    <b-row>
      <b-col md="6" class="mb-2">
        <b-form-group>
          <label for="i-old-work-status-value">
            {{ $t("Current value") }}
          </label>
          <b-form-select
            id="i-old-work-status"
            v-model="oldValue"
            :options="workStatusOptions"
            size="lg"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col md="6" class="mb-2">
        <b-form-group>
          <label for="i-new-work-status-value">
            {{ $t("New value") }}
          </label>
          <validation-provider
            v-slot="{ errors }"
            name="newWorkStatus"
            rules="required"
            mode="lazy"
          >
            <b-form-select
              id="i-new-work-status"
              v-model="newValue"
              :options="workStatusOptions"
              size="lg"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BCard,
  BCardText,
  BCol,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BRow,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@mentoring-platform-validations";
import { useWorkStatusRepository } from '@mentoring-platform/composables'

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BRow,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newValue: null,
      oldValue: null
    };
  },
  created() {
    this.oldValue = this.request.old_value;
    this.newValue = this.request.new_value;
  },
  methods: {
    isValid() {
      return this.$refs['work-status-values-observer'].validate().then((success) => success);
    },
    collectData() {
      return {
        new_value: this.newValue
      }
    }
  },
  setup() {
    const { getWorkStatuses, workStatusOptions } = useWorkStatusRepository()
    getWorkStatuses()

    return {
      workStatusOptions
    }
  },
};
</script>